import * as Yup from 'yup';

export default Yup.object().shape({
  name: Yup.string().required('SCHEMA_ERRORS.BRAND_REQUIRED'),
  type: Yup.string().required('SCHEMA_ERRORS.TYPE_REQUIRED')
});
